import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
// Serialization
import { deserialize } from 'serializr';
import { deviceLogSchema } from './schemas';
// Color
import { deviceLogLevelPalette } from '../components/core/colors';
// Permissions
import permissions from '../constants/Permissions';
// Custom
import { SEARCHFIELD_TYPES } from '../constants/App';
import { findInList } from '../utils/Tools';

/**
* Serialization
*/
const deserializeDeviceLog = (data) => deserialize(deviceLogSchema, data);

/**
* Lists
*/
const { pAdmin } = permissions;

const deviceLogTypesList = [
  {
    key: 'h0',
    header: true,
    value: 'h0',
    labelId: 'deviceLog.tag.power',
  },
  {
    key: 'boot',
    value: 'boot',
    labelId: 'deviceLog.type.boot',
  },
  {
    key: 'reboot',
    value: 'reboot',
    labelId: 'deviceLog.type.reboot',
  },
  {
    key: 'shutdown',
    value: 'shutdown',
    labelId: 'deviceLog.type.shutdown',
  },
  {
    key: 'standby',
    value: 'standby',
    labelId: 'deviceLog.type.standby',
  },
  {
    key: 'power_off',
    value: 'power_off',
    labelId: 'deviceLog.type.power_off',
  },
  {
    key: 'power_on',
    value: 'power_on',
    labelId: 'deviceLog.type.power_on',
  },
  {
    key: 'h1',
    header: true,
    value: 'h1',
    labelId: 'deviceLog.tag.connectivity',
  },
  {
    key: 'online',
    value: 'online',
    labelId: 'deviceLog.type.online',
  },
  {
    key: 'offline',
    value: 'offline',
    labelId: 'deviceLog.type.offline',
  },
  {
    key: 'network_up',
    value: 'network_up',
    labelId: 'deviceLog.type.network_up',
  },
  {
    key: 'network_down',
    value: 'network_down',
    labelId: 'deviceLog.type.network_down',
  },
  {
    key: 'network_operator_change',
    value: 'network_operator_change',
    labelId: 'deviceLog.type.network_operator_change',
  },
  {
    key: 'network_level_change',
    value: 'network_level_change',
    labelId: 'deviceLog.type.network_level_change',
  },
  {
    key: 'network_management_begin',
    value: 'network_management_begin',
    labelId: 'deviceLog.type.network_management_begin',
    permission: pAdmin,
  },
  {
    key: 'network_management_end',
    value: 'network_management_end',
    labelId: 'deviceLog.type.network_management_end',
    permission: pAdmin,
  },
  {
    key: 'network_status',
    value: 'network_status',
    labelId: 'deviceLog.type.network_status',
    permission: pAdmin,
  },
  {
    key: 'network_test_button',
    value: 'network_test_button',
    labelId: 'deviceLog.type.network_test_button',
  },
  {
    key: 'network_blacklist',
    value: 'network_blacklist',
    labelId: 'deviceLog.type.network_blacklist',
  },
  {
    key: 'eth_up',
    value: 'eth_up',
    labelId: 'deviceLog.type.eth_up',
    permission: pAdmin,
  },
  {
    key: 'eth_down',
    value: 'eth_down',
    labelId: 'deviceLog.type.eth_down',
    permission: pAdmin,
  },
  {
    key: 'eth_error',
    value: 'eth_error',
    labelId: 'deviceLog.type.eth_error',
    permission: pAdmin,
  },
  {
    key: 'modem_up',
    value: 'modem_up',
    labelId: 'deviceLog.type.modem_up',
    permission: pAdmin,
  },
  {
    key: 'modem_down',
    value: 'modem_down',
    labelId: 'deviceLog.type.modem_down',
    permission: pAdmin,
  },
  {
    key: 'modem_error',
    value: 'modem_error',
    labelId: 'deviceLog.type.modem_error',
    permission: pAdmin,
  },
  {
    key: 'modem_reset',
    value: 'modem_reset',
    labelId: 'deviceLog.type.modem_reset',
    permission: pAdmin,
  },
  {
    key: 'modem_status',
    value: 'modem_status',
    labelId: 'deviceLog.type.modem_status',
    permission: pAdmin,
  },
  {
    key: 'h2',
    header: true,
    value: 'h2',
    labelId: 'deviceLog.tag.system',
    permission: pAdmin,
  },
  {
    key: 'slave_info',
    value: 'slave_info',
    labelId: 'deviceLog.type.slave_info',
  },
  {
    key: 'slave_update',
    value: 'slave_update',
    labelId: 'deviceLog.type.slave_update',
    permission: pAdmin,
  },
  {
    key: 'slave_error',
    value: 'slave_error',
    labelId: 'deviceLog.type.slave_error',
    permission: pAdmin,
  },
  {
    key: 'slave_timeout',
    value: 'slave_timeout',
    labelId: 'deviceLog.type.slave_timeout',
    permission: pAdmin,
  },
  {
    key: 'factory_reset',
    value: 'factory_reset',
    labelId: 'deviceLog.type.factory_reset',
    permission: pAdmin,
  },
  {
    key: 'process_start',
    value: 'process_start',
    labelId: 'deviceLog.type.process_start',
    permission: pAdmin,
  },
  {
    key: 'opac_warning',
    value: 'opac_warning',
    labelId: 'deviceLog.type.opac_warning',
    permission: pAdmin,
  },
  {
    key: 'commit_error',
    value: 'commit_error',
    labelId: 'deviceLog.type.commit_error',
    permission: pAdmin,
  },
  {
    key: 'rollback_error',
    value: 'rollback_error',
    labelId: 'deviceLog.type.rollback_error',
    permission: pAdmin,
  },
  {
    key: 'database_error',
    value: 'database_error',
    labelId: 'deviceLog.type.database_error',
    permission: pAdmin,
  },
  {
    key: 'database_reset',
    value: 'database_reset',
    labelId: 'deviceLog.type.database_reset',
    permission: pAdmin,
  },
  {
    key: 'internal_error',
    value: 'internal_error',
    labelId: 'deviceLog.type.internal_error',
    permission: pAdmin,
  },
  {
    key: 'circuit_breaker',
    value: 'circuit_breaker',
    labelId: 'deviceLog.type.circuit_breaker',
  },
  {
    key: 'h3',
    header: true,
    value: 'h3',
    labelId: 'deviceLog.tag.idle',
  },
  {
    key: 'test_jumper',
    value: 'test_jumper',
    labelId: 'deviceLog.type.test_jumper',
  },
  {
    key: 'mode_change',
    value: 'mode_change',
    labelId: 'deviceLog.type.mode_change',
    permission: pAdmin,
  },
  {
    key: 'opac_client_error',
    value: 'opac_client_error',
    labelId: 'deviceLog.type.opac_client_error',
    permission: pAdmin,
  },
  {
    key: 'access_way',
    value: 'access_way',
    labelId: 'deviceLog.type.access_way',
  },
  {
    key: 'sync_start',
    value: 'sync_start',
    labelId: 'deviceLog.type.sync_start',
  },
  {
    key: 'sync_done',
    value: 'sync_done',
    labelId: 'deviceLog.type.sync_done',
  },
  {
    key: 'sync_error',
    value: 'sync_error',
    labelId: 'deviceLog.type.sync_error',
    permission: pAdmin,
  },
  {
    key: 'sms_command',
    value: 'sms_command',
    labelId: 'deviceLog.type.sms_command',
  },
  {
    key: 'sms_warning',
    value: 'sms_warning',
    labelId: 'deviceLog.type.sms_warning',
  },
  {
    key: 'sms_sent',
    value: 'sms_sent',
    labelId: 'deviceLog.type.sms_sent',
    permission: pAdmin,
  },
  {
    key: 'server_command',
    value: 'server_command',
    labelId: 'deviceLog.type.server_command',
  },
  {
    key: 'trigger_eth_status',
    value: 'trigger_eth_status',
    labelId: 'deviceLog.type.trigger_eth_status',
  },
  {
    key: 'trigger_eth_error',
    value: 'trigger_eth_error',
    labelId: 'deviceLog.type.trigger_eth_error',
  },
  {
    key: 'trigger_eth_info',
    value: 'trigger_eth_info',
    labelId: 'deviceLog.type.trigger_eth_info',
  },
  {
    key: 'on_demand_allotment_error',
    value: 'on_demand_allotment_error',
    labelId: 'deviceLog.type.on_demand_allotment_error',
  },
];

const deviceLogTagsList = [
  {
    key: 'connectivity',
    value: 'connectivity',
    labelId: 'deviceLog.tag.connectivity',
    icon: 'dLogTagConn',
  },
  {
    key: 'system',
    value: 'system',
    labelId: 'deviceLog.tag.system',
    icon: 'dLogTagSystem',
  },
  {
    key: 'power',
    value: 'power',
    labelId: 'deviceLog.tag.power',
    icon: 'dLogTagPower',
  },
  {
    key: 'idle',
    value: 'idle',
    labelId: 'deviceLog.tag.idle',
    icon: 'dLogTagIdle',
  },
];

const deviceLogLevelsList = [
  {
    key: 'debug',
    value: 'debug',
    labelId: 'deviceLog.level.debug',
    icon: 'debug',
    color: deviceLogLevelPalette.debug,
  },
  {
    key: 'info',
    value: 'info',
    labelId: 'deviceLog.level.info',
    icon: 'info',
    color: deviceLogLevelPalette.info,
  },
  {
    key: 'warning',
    value: 'warning',
    labelId: 'deviceLog.level.warning',
    icon: 'warning',
    color: deviceLogLevelPalette.warning,
  },
  {
    key: 'error',
    value: 'error',
    labelId: 'deviceLog.level.error',
    icon: 'error',
    color: deviceLogLevelPalette.error,
  },
];

const deviceLogOriginsList = [
  {
    key: 'device',
    value: 'device',
    labelId: 'deviceLog.origin.device',
    icon: 'dLogOriginDevice',
  },
  {
    key: 'server',
    value: 'server',
    labelId: 'deviceLog.origin.server',
    icon: 'dLogOriginServer',
  },
];

/**
* Utils
*/
const deviceLogType = (log) => findInList(deviceLogTypesList, 'value', log, 'type');
const deviceLogTag = (log) => findInList(deviceLogTagsList, 'value', log, 'tag');
const deviceLogLevel = (log) => findInList(deviceLogLevelsList, 'value', log, 'level');
const deviceLogOrigin = (log) => findInList(deviceLogOriginsList, 'value', log, 'origin');

/**
* Model
*/
const deviceLog = {
  // Name
  name: 'deviceLog',

  // Serialization
  deserialize: deserializeDeviceLog,

  // Lists
  typesList: deviceLogTypesList,
  tagsList: deviceLogTagsList,
  levelsList: deviceLogLevelsList,
  originsList: deviceLogOriginsList,

  // Utils
  type: deviceLogType,
  tag: deviceLogTag,
  level: deviceLogLevel,
  origin: deviceLogOrigin,

  // List features
  listFeatures: {
    // Default list params
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [
        { field: 'date', dir: 'desc' },
      ],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 2,
      sm: 2,
      md: 4,
      lg: 6,
      xl: 6,
    }),
    columns: [
      {
        key: 'date',
        labelId: 'field.date',
        field: 'date',
        sortable: true,
      },
      {
        key: 'type',
        labelId: 'field.type',
        field: 'type',
        sortable: false,
      },
      {
        key: 'tag',
        labelId: 'field.tag',
        field: 'tag',
        sortable: false,
        className: 'hidden-sm-down table-content-1 table-content-center',
      },
      {
        key: 'level',
        labelId: 'field.level',
        field: 'level',
        sortable: false,
        className: 'hidden-sm-down table-content-1 table-content-center',
      },
      {
        key: 'origin',
        labelId: 'field.origin',
        field: 'origin',
        sortable: false,
        className: 'hidden-md-down table-content-1 table-content-center',
      },
      {
        key: 'desc',
        labelId: 'field.desc',
        field: 'desc',
        sortable: false,
        className: 'hidden-md-down',
      },
    ],

    // Search fields
    searchFields: [
      {
        key: 'type',
        labelId: 'field.type',
        field: 'type',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'type',
        },
      },
      {
        key: 'begin',
        labelId: 'field.afterDate',
        field: 'begin',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.date,
        scope: 'after',
        filter: {
          field: 'date',
        },
      },
      {
        key: 'end',
        labelId: 'field.beforeDate',
        field: 'end',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.date,
        scope: 'before',
        filter: {
          field: 'date',
        },
      },
      {
        key: 'tag',
        labelId: 'field.tag',
        field: 'tag',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'tag',
        },
      },
      {
        key: 'level',
        labelId: 'field.level',
        field: 'level',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'level',
        },
      },
      {
        key: 'origin',
        labelId: 'field.origin',
        field: 'origin',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'origin',
        },
      },
      {
        key: 'desc',
        labelId: 'field.desc',
        field: 'desc',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        scope: 'like',
        filter: {
          field: 'desc',
        },
      },
    ],
  },
};

module.exports = deviceLog;



// WEBPACK FOOTER //
// ./models/deviceLog.js